import { render, staticRenderFns } from "./CategoryDeleteDialog.vue?vue&type=template&id=189751d0"
import script from "./CategoryDeleteDialog.vue?vue&type=script&lang=js"
export * from "./CategoryDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports